<template>
  <inner
    @apply="applyFilter"
    @clear="clear"
  >
    <slot
      :is-selected="isSelected"
      :toggle="toggle"
      :options="options"
    >
      <mobile-multiselect-item
        v-for="option in options"
        :key="option.id"
        :title="option.label || option.value"
        :is-selected="isSelected(option)"
        @click.native="toggle(option)"
      />
    </slot>
  </inner>
</template>

<script>
import MobileMultiselectItem from '@/components/mobile-multiselect/mobile-multiselect-item.vue';
import Inner from '@/components/mobile-multiselect/inner.vue';

import defaultFilterMixin from '@/components/filters/default-filter-mixin';

export default {
  components: { MobileMultiselectItem, Inner },

  mixins: [ defaultFilterMixin ],

  methods: {
    isSelected(option) {
      return this.tempSelectedOptions.some(({ value }) =>  value === option.value);
    },
    toggle(option) {
      if(this.isSelected(option)) {
        this.removeOption(option);
      } else {
        this.addOption(option)
      }
    },
  },
}
</script>
